
import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import LoginForm from './Components/LoginForm';
import { signIn, confirmSignIn } from "@aws-amplify/auth";
import DefinePassword from './DefinePassword';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [code, setCode] = useState('');
  const [setNewPwd, setSetNewPwd] = useState(false);
  const [user, setUser] = useState([]);
  const [error, setError] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [changePwd, setChangePwd] = useState(false);
  // extras
  const [userData, setUserData] = useState(null);

  const changeField = (e) => {
    const { name, value } = e.target;
    if (name === 'email') setEmail(value);
    else if (name === 'password') setPassword(value);
    else if (name === 'newPassword') setNewPassword(value);
    else if (name === 'code') setCode(value);
  };

  const handleLoginAction = async (e) => {
    e.preventDefault();
    let data = {
      username: email,
      password: password
    };
    setLoading(true);
    signIn(data)
      .then(res => {
        if (res.nextStep && res.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
          setSetNewPwd(true);
          setUser(res);
          setLoading(false);
        } else {
          setUserData(JSON.stringify(res.attributes, undefined, 2));
          setError('');
          setRedirect(true);
        }
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  };

  const renderErrorMessage = (error) => (
    <div className="alert alert-danger" role="alert">{error}</div>
  );

  if (setNewPwd) {
    return <DefinePassword user={user} email={email} oldPassword={password} onPasswordDefined={setNewPassword} setRedirect={setRedirect} />;
  }
  if (redirect) {
    window.location.reload();
    return <Redirect to='/admin/planos-do-usuario' />;
  }

  return (
    <div className="container">
      <LoginForm
        loading={loading}
        handleLogin={(e) => handleLoginAction(e)}
        changeField={changeField}
        email={email}
        password={password}
        newPassword={newPassword}
        setNewPwd={setNewPwd}
      />
      {error.length > 0 ? renderErrorMessage(error) : <div />}
    </div>
  );
}

export default Login;
